import React from 'react';

const SvgGq = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="GQ_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="GQ_svg__b" fill="#fff">
        <use xlinkHref="#GQ_svg__a" />
      </mask>
      <rect
        stroke="#F5F5F5"
        strokeWidth={0.5}
        x={0.25}
        y={0.25}
        width={27.5}
        height={19.5}
        rx={2}
      />
      <path fill="#EC3938" mask="url(#GQ_svg__b)" d="M0 13.333h28V20H0z" />
      <path fill="#51B422" mask="url(#GQ_svg__b)" d="M0 0h28v6.667H0z" />
      <path
        d="M13.42 11.909a.973.973 0 0 0 .235-.567l.01-1.684a.332.332 0 0 0-.337-.325h-.323c-.187 0-.234-.104-.106-.232l.869-.869a.329.329 0 0 1 .464 0l.87.87c.127.127.075.231-.107.231h-.323a.337.337 0 0 0-.339.325v1.684c0 .18.106.43.243.567l-.152-.151c.134.134.1.242-.094.242h-.66c-.186 0-.235-.105-.104-.242l-.145.15z"
        fill="#159940"
        mask="url(#GQ_svg__b)"
      />
      <path fill="#258DE7" mask="url(#GQ_svg__b)" d="M0 0l9.333 10L0 20z" />
    </g>
  </svg>
);

export default SvgGq;
